import React from 'react';
import { Link } from 'react-router-dom';
import './buttons.css';

const ButtonOrange = ({ destination, text }) => {
	return (
		<div className="center">
      <Link to={destination} className="orange">
        {text}
      </Link>
    </div>
		);
}

export default ButtonOrange;